import { tabs } from '../../../../../../views/dashboard/service-provider';

export default {
  tabs: {
    [tabs.general]: 'General',
    [tabs.restaurant_details]: 'Restaurant details',
    [tabs.order_conversion]: 'Order conversion',
    [tabs.external_delivery]: 'External delivery',
    [tabs.mobile_app]: 'Mobile app',
    [tabs.customer_success_team]: 'Customer success team',
    [tabs.onboarding_team]: 'Onboarding team',
  },
  date_range: {
    this_month: 'This Month',
    last_month: 'Last Month',
    last_week: 'Last Week',
    last_year: 'Last Year',
    this_week: 'This Week',
    this_year: 'This Year',
    today: 'Today',
    yesterday: 'Yesterday',
    all: 'All',
  },
};
